import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useOljeValidation = () => {
  const { t } = useTranslation();
  const validateOljeSelection = (_: boolean, { olje }: OppvarmingFormData) => {
    const anySelected = olje?.value?.kamin?.selected || olje?.value?.kjel?.selected;

    if (!anySelected) {
      return t('form.oppvarming.olje.error');
    }
    return true;
  };
  return { validateOljeSelection };
};
